import script from "./QuizModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizModal.vue?vue&type=script&setup=true&lang=js"

import "./QuizModal.vue?vue&type=style&index=0&id=1ecc0eca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecc0eca"]])

export default __exports__